import React ,{ useContext }from 'react'

import LoadingBar from '../shared/loadingBar'
import Header from './header'
import Container from './container'
import G from '../../util/globalFunction'
import {GlobalContext} from '../../context/globalContext'
import webAccessibilityMark from '../../static/images/common/web_accessibility_mark.png'

const PublicLayout = props => {
    const { title, mode, parm, passUrl, layout, menu, children } = props
    
    return (
        <div className="flex flex-col">
             <div id="skip">
                <ul>
                    <li><a href="#header">메뉴 바로가기</a></li>
                    <li><a href="#skip_con">본문 바로가기</a></li>
                    <li><a href="#footer">하단 바로가기</a></li>
                </ul>
            </div>
            <Header/>
            <LoadingBar position={26}/>
            <Container Container>{children}</Container>
            <div id="footer">
                <div className="inner">
                    <ul>
                        <li>
                            <a href="https://www.kist.re.kr/ko/pop-up/pop_private06.do" target="_blank">
                                {G.t('trem.lang.home.0025')}
                            </a>{/* 개인정보처리방침 */}
                        </li>
                        <li>
                            <a href="https://www.seoulbiohub.kr/front/intropage/intropageShow.do?page_id=9f603da0fad04dcc861eab7d77b547b7" target="_blank">
                                {G.t('trem.lang.home.0026')}
                            </a>{/* 서비스이용약관 */}
                        </li>
                        <li>
                             <a href="javascript:void(0);" onClick={() => G.gotoPage('/location/main')}>
                                {G.t('trem.lang.home.0027')}
                            </a>{/* 찾아오시는 길 */}
                        </li>
                    </ul>
                    <p>{G.t('trem.lang.home.0028')}</p>{/* 서울특별시 동대문구 회기로 117-3 */}
                    <p>Copyright© 2017 BY SEOUL BIOHUB ALL Rights Reserved.</p>
                    <div className='footer_btn'>
                        <ul>
                            <li className="btn_wa">
                                <a
                                    href="http://kwacc.or.kr/CertificationSite/WA/1911/Detail?page=1"
                                    title={G.t('trem.lang.home.1254') + `_` + G.t('trem.lang.home.1255')/* 한국웹접근성평가센터 인증현황 바로가기_새창 */}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    <img
                                        src={webAccessibilityMark}
                                        alt={G.t('trem.lang.home.1256')/* 국가공인 정보통신접근성 품질인증마크 */}
                                        style={{width: '85px', height: '60px'}}
                                    />
                                </a>
                            </li>
                            <li>
                                <a href="#" className="btn_top">TOP</a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default PublicLayout
